import React from 'react';

import { useRouter } from 'expo-router';

import ConfirmDialog from 'components/confirm-dialog';
import { t } from 'state/intl/translations';
import { useProductWizardContext } from 'state/product-wizard-v2';
import useProductWizardFlow from 'state/product-wizard-v2/hooks/use-product-wizard-flow';
import { ProductWizardStep } from 'state/product-wizard-v2/types';

import { logCTAEvent } from '../../utils';
import { BodyComponent } from '../body-component';

export const CloseConfirmationDialog = () => {
  const { back } = useRouter();

  const { showCloseDialog, handleCloseDialog } = useProductWizardContext();
  const { currentStep } = useProductWizardFlow();
  const heading = t('productDetailCloseHeading');
  const content = t('productDetailCloseContent');

  const confirmLabel = t('leaveNow');
  const cancelLabel = t('continueCustomizing');
  const shouldShowDialog = showCloseDialog && currentStep !== ProductWizardStep.ProductHome;

  return (
    <ConfirmDialog
      showDialog={shouldShowDialog}
      modalAppearanceEventMessage="Product Detail Close Dialog"
      bodyComponent={<BodyComponent heading={heading} content={content} />}
      confirmLabel={confirmLabel}
      cancelLabel={cancelLabel}
      onConfirm={() => {
        logCTAEvent(confirmLabel);
        back();
      }}
      onCancel={() => {
        logCTAEvent(cancelLabel);
        handleCloseDialog(false);
      }}
    />
  );
};
